import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, Building2, Sparkles, Phone, ArrowRight, ChevronDown, UtensilsCrossed, Shirt, Flame, Refrigerator, Microwave, DoorOpen, Warehouse, PanelTop, SunDim, Blinds, BedDouble, Trash2, Fence } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
import { ServiceNav } from '../components/ServiceNav';
const cardClass = 'bg-white rounded-2xl border border-gray-200 p-8 md:p-10 shadow-sm';
const stepHeadingClass = 'font-bebas text-2xl md:text-3xl text-[#1a2744] pb-3 border-b border-gray-200';
const labelClass = 'text-[#1a2744] font-medium text-sm';
const inputClass = 'w-full border border-gray-200 rounded-lg px-4 py-3 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all placeholder-gray-400';
const selectClass = 'w-full border border-gray-200 rounded-lg px-4 py-3 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all appearance-none cursor-pointer';
type PillGroupProps = {
  options: string[];
  selected: string;
  onSelect: (val: string) => void;
};
function PillGroup({
  options,
  selected,
  onSelect
}: PillGroupProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-1013">
      {options.map(opt => <button key={opt} type="button" onClick={() => onSelect(opt)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all border ${selected === opt ? 'bg-[#e91e8c] border-[#e91e8c] text-white shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:border-[#e91e8c] hover:text-[#e91e8c]'}`} data-id="element-1014">
          {opt}
        </button>)}
    </div>;
}
const extras = [{
  name: 'Washing dishes',
  price: 7,
  icon: UtensilsCrossed
}, {
  name: 'Laundry (wash & fold)',
  price: 7,
  icon: Shirt
}, {
  name: 'Inside of oven',
  price: 7,
  icon: Flame
}, {
  name: 'Inside of fridge',
  price: 7,
  icon: Refrigerator
}, {
  name: 'Inside microwave',
  price: 7,
  icon: Microwave
}, {
  name: 'Interior of Kitchen Cabinets',
  price: 7,
  icon: DoorOpen
}, {
  name: 'Finished Basement',
  price: 7,
  icon: Warehouse
}, {
  name: 'Hand Wipe Baseboards',
  price: 7,
  icon: PanelTop
}, {
  name: 'Interior Windows',
  price: 7,
  icon: SunDim
}, {
  name: 'Wet Wipe Blinds',
  price: 7,
  icon: Blinds
}, {
  name: 'Change Sheets',
  price: 7,
  icon: BedDouble
}, {
  name: 'Property Cleanup',
  price: 7,
  icon: Trash2
}, {
  name: 'Patio or Balcony',
  price: 7,
  icon: Fence
}];
const timeSlots = ['14:00', '15:00'];
export function MoveInMoveOutQuote() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Step 1 - Contact
  const [contact, setContact] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContact({
      ...contact,
      [e.target.name]: e.target.value
    });
  };
  // Step 2 - Location
  const [location, setLocation] = useState({
    address: '',
    unit: '',
    city: '',
    postalCode: ''
  });
  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocation({
      ...location,
      [e.target.name]: e.target.value
    });
  };
  // Step 3 - Cleaning details
  const [hours, setHours] = useState('2');
  const [cleaners, setCleaners] = useState('1');
  const [bedrooms, setBedrooms] = useState('');
  const [bathrooms, setBathrooms] = useState('');
  const [additionalRooms, setAdditionalRooms] = useState('');
  const [sqFeet, setSqFeet] = useState('');
  const [access, setAccess] = useState('');
  const [homeStatus, setHomeStatus] = useState('');
  const [parking, setParking] = useState('');
  // Step 4 - Extras
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (name: string) => {
    setSelectedExtras(prev => prev.includes(name) ? prev.filter(e => e !== name) : [...prev, name]);
  };
  // Step 5 - Date & Time
  const [date, setDate] = useState('');
  const [timeSlot, setTimeSlot] = useState('');
  // Step 6 - Access details
  const [accessDetails, setAccessDetails] = useState('');
  return <div className="min-h-screen w-full font-sans bg-white flex flex-col" data-id="element-1015">
      <SEOHead title="Book Move-In / Move-Out Cleaning | Smith & Jengs Cleaning Services" description="Book your move-in or move-out cleaning service in Bicester and Oxfordshire. End of tenancy cleaning, online booking in 60 seconds." canonical="https://smithandjengs.com/move-in-move-out-quote" data-id="element-1016" />
      <BreadcrumbSchema items={[{
      name: 'Home',
      url: 'https://smithandjengs.com/'
    }, {
      name: 'Move-In / Move-Out',
      url: 'https://smithandjengs.com/move-in-move-out-quote'
    }, {
      name: 'Book Online',
      url: 'https://smithandjengs.com/move-in-move-out-quote'
    }]} data-id="element-1017" />
      <Navbar data-id="element-1018" />

      <main className="flex-1 pt-24" data-id="element-1019">
        <ServiceNav data-id="element-1020" />

        {/* Header */}
        <section className="w-full bg-white pt-12 md:pt-16 pb-12 px-4 md:px-12" data-id="element-1021">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-5xl w-full mx-auto text-center" data-id="element-1022">
            <h1 className="font-bebas text-[#1a2744] leading-[0.85] tracking-wide mb-6" data-id="element-1023">
              <span className="text-5xl md:text-6xl lg:text-7xl block" data-id="element-1024">
                BOOK ONLINE
              </span>
              <span className="text-3xl md:text-4xl lg:text-5xl block text-[#e91e8c]" data-id="element-1025">
                MOVE-IN / MOVE-OUT
              </span>
            </h1>
            <p className="text-gray-600 font-medium max-w-2xl mx-auto text-lg" data-id="element-1026">
              Book your before/after move cleaning in 60 seconds. End of tenancy
              cleaning made simple.
            </p>
          </motion.div>
        </section>

        {/* Form Section */}
        <section className="w-full bg-[#f8f9fa] py-12 md:py-16 px-4 md:px-8" id="booking-form" data-id="element-1027">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-4xl w-full mx-auto" data-id="element-1028">
            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-1029">
              {/* STEP 1: Contact */}
              <div className={cardClass} data-id="element-1030">
                <h3 className={stepHeadingClass} data-id="element-1031">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1032">STEP 1:</span> Contact
                  Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1033">
                  <div className="space-y-2" data-id="element-1034">
                    <label className={labelClass} data-id="element-1035">First Name</label>
                    <input type="text" name="firstName" value={contact.firstName} onChange={handleContactChange} placeholder="First Name" className={inputClass} data-id="element-1036" />
                  </div>
                  <div className="space-y-2" data-id="element-1037">
                    <label className={labelClass} data-id="element-1038">Last Name</label>
                    <input type="text" name="lastName" value={contact.lastName} onChange={handleContactChange} placeholder="Last Name" className={inputClass} data-id="element-1039" />
                  </div>
                  <div className="space-y-2" data-id="element-1040">
                    <label className={labelClass} data-id="element-1041">Email</label>
                    <input type="email" name="email" value={contact.email} onChange={handleContactChange} placeholder="Email Address" className={inputClass} data-id="element-1042" />
                  </div>
                  <div className="space-y-2" data-id="element-1043">
                    <label className={labelClass} data-id="element-1044">Phone Number</label>
                    <input type="tel" name="phone" value={contact.phone} onChange={handleContactChange} placeholder="Phone Number" className={inputClass} data-id="element-1045" />
                  </div>
                </div>
              </div>

              {/* STEP 2: Location */}
              <div className={cardClass} data-id="element-1046">
                <h3 className={stepHeadingClass} data-id="element-1047">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1048">STEP 2:</span> Cleaning
                  Location
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1049">
                  <div className="space-y-2" data-id="element-1050">
                    <label className={labelClass} data-id="element-1051">Street Address</label>
                    <input type="text" name="address" value={location.address} onChange={handleLocationChange} placeholder="Enter a location" className={inputClass} data-id="element-1052" />
                  </div>
                  <div className="space-y-2" data-id="element-1053">
                    <label className={labelClass} data-id="element-1054">Unit/Apt/Suite #</label>
                    <input type="text" name="unit" value={location.unit} onChange={handleLocationChange} placeholder="Unit/Apt/Suite #" className={inputClass} data-id="element-1055" />
                  </div>
                  <div className="space-y-2" data-id="element-1056">
                    <label className={labelClass} data-id="element-1057">City</label>
                    <input type="text" name="city" value={location.city} onChange={handleLocationChange} placeholder="City" className={inputClass} data-id="element-1058" />
                  </div>
                  <div className="space-y-2" data-id="element-1059">
                    <label className={labelClass} data-id="element-1060">Postal Code</label>
                    <input type="text" name="postalCode" value={location.postalCode} onChange={handleLocationChange} placeholder="Postal Code" className={inputClass} data-id="element-1061" />
                  </div>
                </div>
              </div>

              {/* STEP 3: Cleaning Details */}
              <div className={cardClass} data-id="element-1062">
                <h3 className={stepHeadingClass} data-id="element-1063">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1064">STEP 3:</span> Tell Us
                  About the Cleaning
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1065">
                  All cleaning include cleaning the kitchen.
                </p>
                <div className="space-y-6 mt-8" data-id="element-1066">
                  {/* Hours & Cleaners */}
                  <div data-id="element-1067">
                    <label className={`${labelClass} block mb-3`} data-id="element-1068">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1069">
                      <div className="relative" data-id="element-1070">
                        <select value={hours} onChange={e => setHours(e.target.value)} className={selectClass} data-id="element-1071">
                          {[2, 3, 4, 5, 6, 7, 8].map(h => <option key={h} value={String(h)} data-id="element-1072">
                              {h} Hours
                            </option>)}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1073" />
                      </div>
                      <div className="relative" data-id="element-1074">
                        <select value={cleaners} onChange={e => setCleaners(e.target.value)} className={selectClass} data-id="element-1075">
                          {[1, 2, 3, 4].map(c => <option key={c} value={String(c)} data-id="element-1076">
                              {c} Cleaner{c > 1 ? 's' : ''}
                            </option>)}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1077" />
                      </div>
                    </div>
                  </div>

                  {/* Bedrooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1078">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1079">
                      Bedrooms
                    </label>
                    <div className="relative md:w-64" data-id="element-1080">
                      <select value={bedrooms} onChange={e => setBedrooms(e.target.value)} className={selectClass} data-id="element-1081">
                        <option value="" disabled data-id="element-1082">
                          Select
                        </option>
                        <option value="studio" data-id="element-1083">Studio / 1 Bedroom</option>
                        <option value="2" data-id="element-1084">2 Bedrooms</option>
                        <option value="3" data-id="element-1085">3 Bedrooms</option>
                        <option value="4" data-id="element-1086">4 Bedrooms</option>
                        <option value="5+" data-id="element-1087">5+ Bedrooms</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1088" />
                    </div>
                  </div>

                  {/* Bathrooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1089">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1090">
                      Bathrooms
                    </label>
                    <div className="relative md:w-64" data-id="element-1091">
                      <select value={bathrooms} onChange={e => setBathrooms(e.target.value)} className={selectClass} data-id="element-1092">
                        <option value="" disabled data-id="element-1093">
                          Select
                        </option>
                        <option value="1" data-id="element-1094">1 Bathroom</option>
                        <option value="2" data-id="element-1095">2 Bathrooms</option>
                        <option value="3" data-id="element-1096">3 Bathrooms</option>
                        <option value="4+" data-id="element-1097">4+ Bathrooms</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1098" />
                    </div>
                  </div>

                  {/* Additional Rooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1099">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1100">
                      Additional Rooms (dining room, living room, office, etc)
                    </label>
                    <div className="relative md:w-64" data-id="element-1101">
                      <select value={additionalRooms} onChange={e => setAdditionalRooms(e.target.value)} className={selectClass} data-id="element-1102">
                        <option value="" disabled data-id="element-1103">
                          Select
                        </option>
                        <option value="0" data-id="element-1104">No additional rooms</option>
                        <option value="1" data-id="element-1105">1</option>
                        <option value="2" data-id="element-1106">2</option>
                        <option value="3" data-id="element-1107">3</option>
                        <option value="4+" data-id="element-1108">4+</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1109" />
                    </div>
                  </div>

                  {/* Total Square Feet */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1110">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1111">
                      Total Square feet? (incl. Basement)
                    </label>
                    <div className="relative md:w-64" data-id="element-1112">
                      <select value={sqFeet} onChange={e => setSqFeet(e.target.value)} className={selectClass} data-id="element-1113">
                        <option value="" disabled data-id="element-1114">
                          Select
                        </option>
                        <option value="less-than-1000" data-id="element-1115">Less than 1000</option>
                        <option value="1000-2000" data-id="element-1116">1000 - 2000</option>
                        <option value="2000-3000" data-id="element-1117">2000 - 3000</option>
                        <option value="3000+" data-id="element-1118">3000+</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1119" />
                    </div>
                  </div>

                  {/* How do we access */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1120">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1121">
                      How do we access the premises?
                    </label>
                    <div className="relative md:w-64" data-id="element-1122">
                      <select value={access} onChange={e => setAccess(e.target.value)} className={selectClass} data-id="element-1123">
                        <option value="" disabled data-id="element-1124">
                          Select
                        </option>
                        <option value="meet" data-id="element-1125">
                          I will meet you at the location
                        </option>
                        <option value="lockbox" data-id="element-1126">Lock box</option>
                        <option value="keys" data-id="element-1127">Pick up keys</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1128" />
                    </div>
                  </div>

                  {/* Status of the home */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1129">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1130">
                      Status of the home...
                    </label>
                    <div className="relative md:w-64" data-id="element-1131">
                      <select value={homeStatus} onChange={e => setHomeStatus(e.target.value)} className={selectClass} data-id="element-1132">
                        <option value="" disabled data-id="element-1133">
                          Select
                        </option>
                        <option value="empty" data-id="element-1134">Completely Empty</option>
                        <option value="partial" data-id="element-1135">Partially Furnished</option>
                        <option value="furnished" data-id="element-1136">Fully Furnished</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1137" />
                    </div>
                  </div>

                  {/* Parking */}
                  <div className="space-y-3" data-id="element-1138">
                    <label className={labelClass} data-id="element-1139">Parking</label>
                    <PillGroup options={['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot']} selected={parking} onSelect={setParking} data-id="element-1140" />
                  </div>
                </div>
              </div>

              {/* STEP 4: Extras */}
              <div className={cardClass} data-id="element-1141">
                <h3 className={stepHeadingClass} data-id="element-1142">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1143">STEP 4:</span> Extras?
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1144">
                  Free up more of your precious time for what matters most.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-id="element-1145">
                  {extras.map(({
                  name,
                  price,
                  icon: IconComp
                }) => {
                  const isActive = selectedExtras.includes(name);
                  return <button key={name} type="button" onClick={() => toggleExtra(name)} className={`flex flex-col items-center text-center gap-3 p-5 rounded-xl border-2 transition-all ${isActive ? 'border-[#e91e8c] bg-[#e91e8c]/5 shadow-sm' : 'border-gray-200 bg-white hover:border-[#e91e8c]/40'}`} data-id="element-1146">
                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${isActive ? 'bg-[#e91e8c]/10 text-[#e91e8c]' : 'bg-[#f8f9fa] text-[#1a2744]'}`} data-id="element-1147">
                          <IconComp className="w-6 h-6" data-id="element-1148" />
                        </div>
                        <span className="text-xs font-medium text-[#1a2744] leading-tight" data-id="element-1149">
                          {name}
                        </span>
                        <span className={`text-xs font-semibold ${isActive ? 'text-[#e91e8c]' : 'text-gray-500'}`} data-id="element-1150">
                          £{price}
                        </span>
                      </button>;
                })}
                </div>
              </div>

              {/* STEP 5: Date & Time */}
              <div className={cardClass} data-id="element-1151">
                <h3 className={stepHeadingClass} data-id="element-1152">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1153">STEP 5:</span> Date of
                  Service
                </h3>
                <div className="space-y-6 mt-8" data-id="element-1154">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1155">
                    <div className="space-y-2" data-id="element-1156">
                      <label className={labelClass} data-id="element-1157">Select a date</label>
                      <input type="date" value={date} onChange={e => setDate(e.target.value)} className={inputClass} data-id="element-1158" />
                    </div>
                    <div className="space-y-2" data-id="element-1159">
                      <label className={labelClass} data-id="element-1160">Select a time slot</label>
                      <div className="flex gap-3" data-id="element-1161">
                        {timeSlots.map(slot => <button key={slot} type="button" onClick={() => setTimeSlot(slot)} className={`flex-1 px-4 py-3 rounded-lg text-sm font-medium transition-all border ${timeSlot === slot ? 'bg-[#e91e8c] border-[#e91e8c] text-white shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:border-[#e91e8c] hover:text-[#e91e8c]'}`} data-id="element-1162">
                            {slot}
                          </button>)}
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-400" data-id="element-1163">
                    For same day bookings, a customer service agent will call
                    you.
                  </p>
                </div>
              </div>

              {/* STEP 6: Access Details */}
              <div className={cardClass} data-id="element-1164">
                <h3 className={stepHeadingClass} data-id="element-1165">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1166">STEP 6:</span> Access
                  Details & Other Info
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1167">
                  If your instructions to access the premise was either 'Pick up
                  Keys' or 'Lock Box', please include address for pick up or the
                  code to the lock box here.
                </p>
                <div className="mt-6" data-id="element-1168">
                  <textarea value={accessDetails} onChange={e => setAccessDetails(e.target.value)} placeholder="Enter access details, special instructions, or any other information..." rows={4} className="w-full border border-gray-200 rounded-lg p-4 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all resize-none placeholder-gray-400" data-id="element-1169" />
                </div>
              </div>

              {/* STEP 7: Submit */}
              <div className={cardClass} data-id="element-1170">
                <div className="text-center space-y-4" data-id="element-1171">
                  <h3 className="font-bebas text-2xl md:text-3xl text-[#1a2744]" data-id="element-1172">
                    Ready to Book?
                  </h3>
                  <p className="text-gray-500 text-sm max-w-md mx-auto" data-id="element-1173">
                    Review your details above and click below to confirm your
                    move-in/move-out cleaning. We'll send you a confirmation
                    email right away.
                  </p>
                  <button type="submit" className="bg-[#e91e8c] hover:bg-[#d0187c] text-white px-12 py-4 rounded-full font-semibold tracking-wider text-lg transition-colors shadow-lg hover:shadow-xl" data-id="element-1174">
                    BOOK NOW
                  </button>
                </div>
              </div>
            </form>
          </motion.div>
        </section>

        {/* Explore Our Services */}
        <section className="w-full bg-white py-20 px-4 md:px-12 border-t border-gray-200" data-id="element-1175">
          <div className="max-w-7xl mx-auto" data-id="element-1176">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-16" data-id="element-1177">
              <h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-[#1a2744] tracking-wide" data-id="element-1178">
                EXPLORE OUR <span className="text-[#e91e8c]" data-id="element-1179">SERVICES</span>
              </h2>
              <p className="text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-1180">
                Discover our full range of professional cleaning solutions
                tailored to your needs.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1181">
              {[{
              title: 'Basic Home Cleaning',
              desc: 'Regular maintenance to keep your home spotless.',
              link: '/basic-home-cleaning',
              icon: Home
            }, {
              title: 'Spring / Deep Cleaning',
              desc: 'Thorough, top-to-bottom detail cleaning.',
              link: '/spring-deep-cleaning',
              icon: Sparkles
            }, {
              title: 'Commercial Cleaning',
              desc: 'Professional cleaning for your business.',
              link: '/commercial-cleaning',
              icon: Building2
            }, {
              title: 'Contact Us',
              desc: 'Get in touch for custom requests.',
              link: '/contact-us',
              icon: Phone
            }].map((service, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.1
            }} data-id="element-1182">
                  <Link to={service.link} className="group block h-full bg-[#f8f9fa] rounded-xl p-8 hover:shadow-md transition-all border border-gray-100 hover:border-[#5bbcd5]" data-id="element-1183">
                    <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 group-hover:bg-[#5bbcd5]/10 transition-colors" data-id="element-1184">
                      <service.icon className="w-6 h-6 text-[#1a2744] group-hover:text-[#5bbcd5] transition-colors" data-id="element-1185" />
                    </div>
                    <h3 className="font-bebas text-2xl text-[#1a2744] mb-3 tracking-wide group-hover:text-[#e91e8c] transition-colors" data-id="element-1186">
                      {service.title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-6 line-clamp-2" data-id="element-1187">
                      {service.desc}
                    </p>
                    <div className="flex items-center text-[#5bbcd5] font-medium text-sm mt-auto" data-id="element-1188">
                      Learn more
                      <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1189" />
                    </div>
                  </Link>
                </motion.div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1190" />
    </div>;
}